import AllhomesAgencySearchResults from './allhomes-agency-search-results';
import { fromUrlQuery as sortFromUrlQuery } from './utils/sort-options';
import { fromUrlQuery as localitiesFromUrlQuery } from './utils/localities';
export { sortFromUrlQuery, localitiesFromUrlQuery };
export default AllhomesAgencySearchResults;